import React, {
  useEffect, useMemo, useState,
} from 'react';
import WebViewContext from '../webViewContext';

export default function WebViewProvider(props) {
  const {
    children,
  } = props;

  const [data, setData] = useState({
    mobile: false,
    referer: '',
  });
  const defaultValues = useMemo(() => ({
    ...data,
  }), [data]);

  useEffect(() => {
    // eslint-disable-next-line no-restricted-globals
    const params = new URLSearchParams(location.search);

    const isMobile = params.get('mobile');
    const referer = decodeURI(params.get('referer') || '');

    setData({
      mobile: Boolean(isMobile),
      referer,
    });
  }, []);

  return (
    <WebViewContext.Provider value={defaultValues}>
      {children}
    </WebViewContext.Provider>
  );
}
